export type GuideFeatureIcon = 'target' | 'message' | 'layout' | 'timer' | 'sliders' | 'eye';

export const guideFeatures: { label: string; text: string; icon: GuideFeatureIcon; bg: string; fg: string }[] = [
  {
    label: 'Goals & equipment',
    text: 'A clear goal for the lesson and the exact equipment to bring out.',
    icon: 'target',
    bg: '#B7E16D',
    fg: '#082721',
  },
  {
    label: 'Instructions',
    text: 'Concrete, ready-to-say cues so you know what to tell the class.',
    icon: 'message',
    bg: '#082721',
    fg: '#B7E16D',
  },
  {
    label: 'Diagrams',
    text: 'Court and station diagrams that show where players, cones and targets go.',
    icon: 'layout',
    bg: '#F2F5E9',
    fg: '#154B3E',
  },
  {
    label: 'Timings',
    text: 'Every activity is timed to fit a 40-minute lesson from warm-up to close.',
    icon: 'timer',
    bg: '#154B3E',
    fg: '#F2F5E9',
  },
  {
    label: 'Easier / harder',
    text: 'Simple options to adjust each activity for a mixed-level group.',
    icon: 'sliders',
    bg: '#B7E16D',
    fg: '#082721',
  },
  {
    label: 'Observation',
    text: 'What to watch for, so you can see who is ready to move on.',
    icon: 'eye',
    bg: '#082721',
    fg: '#B7E16D',
  },
];

export const teachingSteps = [
  {
    title: 'Open the plan',
    text: 'Start with Lesson 1. Read the goal, equipment list and timings before class.',
  },
  {
    title: 'Set up the space',
    text: 'Follow the diagram to place cones, targets and groups before pupils arrive.',
  },
  {
    title: 'Teach and adapt',
    text: 'Use the instructions, switch to easier or harder options, and note what you observe.',
  },
];
